import { createSlotsContext } from "@grandvisionhq/slots";
const [SignUpFormSlotsProvider, useSignUpFormSlots] = createSlotsContext({
  displayName: "SignUpFormSlotsContext"
});
export {
  SignUpFormSlotsProvider,
  useSignUpFormSlots
};
//# sourceMappingURL=SignUpFormSlotsContext.js.map
